import { useEncrypt } from "../hooks/useEncrypt"

const GetStorageUser = () => {
    const { decrypt } = useEncrypt()

    const userData = localStorage.getItem('user')
    
    if (!userData) {
        return userData
    }
    
    try {
        const decryptData = decrypt(userData)
        return JSON.parse(decryptData)
    } catch {
        return null
    }
}

export default GetStorageUser